import { render, staticRenderFns } from "./FreeGeneration.vue?vue&type=template&id=5ee8d80f"
import script from "./FreeGeneration.vue?vue&type=script&lang=js"
export * from "./FreeGeneration.vue?vue&type=script&lang=js"
import style0 from "./FreeGeneration.vue?vue&type=style&index=0&id=5ee8d80f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports